import { ActionReducerMapBuilder } from '@reduxjs/toolkit';
import { createDemandPoll } from 'reduxStore/project/demandPoll/asyncActions';
import { ProjectState } from 'reduxStore/project/initialState';
import { Resource } from 'model/Resource';

export const demandPollReducer = (builder: ActionReducerMapBuilder<ProjectState.Domain>) => {
  builder.addCase(createDemandPoll.fulfilled, (state, action) => {
    state.currentResource = Resource.createResolvedResource({ data: action.payload });
    state.isPulseTemplateFullyLoaded = true;
  });
};
